<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="600"
  >
    <a-form :model="formState" :rules="rules" ref="formRef">
      <a-form-item label="变更内容" name="changeContent">
        <a-input
          v-model:value="formState.changeContent"
          placeholder="请输入变更内容"
        ></a-input>
      </a-form-item>

      <a-form-item label="组长首样确认" name="isGroupLeaderFirstConfirm">
        <a-select
          v-model:value="formState.isGroupLeaderFirstConfirm"
          placeholder="组长是否首样确认"
        >
          <a-select-option :value="true">是</a-select-option>
          <a-select-option :value="false">否</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="组员二次培训" name="isGroupMembersSecondaryTrain">
        <a-select
          v-model:value="formState.isGroupMembersSecondaryTrain"
          placeholder="组员是否二次培训"
        >
          <a-select-option :value="true">是</a-select-option>
          <a-select-option :value="false">否</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="组员首样确认" name="isGroupMembersFirstConfirm">
        <a-select
          v-model:value="formState.isGroupMembersFirstConfirm"
          placeholder="组员首样是否确认"
        >
          <a-select-option :value="true">是</a-select-option>
          <a-select-option :value="false">否</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="组员质量抽查" name="isGroupMembersQualitySpotCheck">
        <a-select
          v-model:value="formState.isGroupMembersQualitySpotCheck"
          placeholder="组员质量是否抽查"
        >
          <a-select-option :value="true">是</a-select-option>
          <a-select-option :value="false">否</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { timeStampToTime, Toast } from "@/utils";
import { computed, defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { showUploading, hideUploading } from "@/utils/index";
import {
  saveOrUpdateProcessChange,
  uploadProduceAttachment,
} from "@/request/view/product";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";

export default defineComponent({
  props: {
    type: String,
    produceOrTpc: String,
  },
  components: { uploadImgVue, uploadVideoVue },
  setup(props, context) {
    const store = useStore();
    const formRef = ref();
    const modalConfig = reactive({
      visible: false,
      title: null,
    });
    const imgRef = ref();
    const videoRef = ref();

    const formState = reactive({
      id: null,
      changeContent: null,
      isGroupLeaderFirstConfirm: null,
      localDate: null,
      isGroupMembersFirstConfirm: null,
      picture: null,
      isGroupMembersQualitySpotCheck: null,
      video: null,
      produceOrTpc: null,
      isGroupMembersSecondaryTrain: null,
      project: "swan",
      userId: null,
      username: null,
    });

    const isEdit = computed(() => {
      if (modalConfig.title === "添加工艺变更") {
        return true;
      }
      return formState.userId === store.state.user.user.id;
    });

    const rules = {
      changeContent: [
        {
          required: true,
          message: "请输入变更内容",
          trigger: "change",
          type: "any",
        },
      ],
      isGroupLeaderFirstConfirm: [
        {
          required: true,
          message: "请选择组长首样确认",
          trigger: "change",
          type: "any",
        },
      ],
      isGroupMembersSecondaryTrain: [
        {
          required: true,
          message: "请选择组员二次培训",
          trigger: "change",
          type: "any",
        },
      ],
      isGroupMembersFirstConfirm: [
        {
          required: true,
          message: "请选择组员首样确认",
          trigger: "change",
          type: "any",
        },
      ],
      isGroupMembersQualitySpotCheck: [
        {
          required: true,
          message: "请选择组员质量抽查",
          trigger: "change",
          type: "any",
        },
      ],
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.visible = false;
      modalConfig.title = null;
    };

    const openModal = (type, data) => {
      modalConfig.visible = true;
      if (type === "addProcessUpdate") {
        modalConfig.title = "添加工艺变更";
        formState.localDate = timeStampToTime("", "upload");
        const { id, username } = store.state.user.user;
        formState.userId = id;
        formState.username = username;
        formState.type = props.type;
        formState.project = "swan";
        formState.produceOrTpc = props.produceOrTpc;
        console.log(formState, "获取的数据是什么");
      } else if (type === "editProcessUpdate") {
        modalConfig.title = "编辑工艺变更";
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
    };

    const handleOk = () => {
      try {
        formRef.value
          .validate()
          .then(async () => {
            showUploading();
            await saveOrUpdateProcessChange(formState)
              .then((res) => {
                let type = res.code === 200 ? "success" : "warning";
                Toast(type, res.message, 3);
                handleCancel();
                context.emit("updateTable");
                hideUploading();
              })
              .catch((err) => {
                console.log(err);
                hideUploading();
              });
          })
          .catch((err) => {
            console.log(err, "捕获错误");
            if (err.errorFields && err.errorFields.length > 0) {
              const [errText] = err.errorFields[0].errors;
              Toast("warning", errText, 3);
            }
          });
      } catch (error) {
        console.log(error, "catch 捕获错误");
      }
    };

    return {
      formRef,
      openModal,
      modalConfig,
      handleOk,
      handleCancel,
      formState,
      rules,
      isEdit,
      imgRef,
      videoRef,
      uploadProduceAttachment,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
